module.exports = __webpack_public_path__ + "4a2b6259052a18da48022b52444bb446.png";